import React, { useEffect } from 'react';
import ContactForm from '../components/ContactForm';

const DemandeDevis = () => {
  // Initialiser Google Ads
  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'AW-16912204930');
    }
  }, []);
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">Demande de devis</div>
          <h1 className="page-title">Demandez votre devis gratuit</h1>
          <p className="section-description">
            Remplissez ce formulaire pour recevoir un devis personnalisé et gratuit pour l'entretien de votre jardin. Notre équipe vous répondra dans les plus brefs délais.
          </p>
        </div>

        <div className="modern-section" style={{paddingTop: '2rem'}}>
          <div className="section-container">
            <ContactForm type="ads" />
          </div>
        </div>

        {/* Informations supplémentaires */}
        <div className="modern-section" style={{paddingTop: '2rem', paddingBottom: '3rem'}}>
          <div className="section-container">
            <div className="cards-grid" style={{gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem'}}>
              <div className="modern-card" style={{textAlign: 'center'}}>
                <div className="card-icon" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>⚡</div>
                <h3 className="card-title">Réponse rapide</h3>
                <p className="card-description">
                  Réponse sous 24h ouvrées
                </p>
              </div>
              <div className="modern-card" style={{textAlign: 'center'}}>
                <div className="card-icon" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>💰</div>
                <h3 className="card-title">Devis gratuit</h3>
                <p className="card-description">
                  Sans engagement de votre part
                </p>
              </div>
              <div className="modern-card" style={{textAlign: 'center'}}>
                <div className="card-icon" style={{fontSize: '2.5rem', marginBottom: '1rem'}}>✓</div>
                <h3 className="card-title">Expertise professionnelle</h3>
                <p className="card-description">
                  Équipe qualifiée et expérimentée
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemandeDevis;

